import {
  GeoPoint
} from '../index';

declare var Object: any;
export interface SignatureViewInterface {
  "id": number;
  "tenantId": number;
  "userId": number;
  "consumerId"?: number;
  "employeeId"?: number;
  "vehicleId"?: number;
  "requestID": string;
  "manifestRecId"?: string;
  "scheduledTime"?: string;
  "pickupTime"?: string;
  "dropoffTime"?: string;
  "arrivedTime"?: string;
  "imgFileId"?: string;
  "type": string;
  "captured": number;
  "unableToSign": number;
  "oneWayOnly": number;
  "dateTimeOfService": Date;
  "dateTime": Date;
  "marker"?: string;
  "status"?: string;
  "validationState": string;
  "location"?: GeoPoint;
  "meta": any;
  "note"?: string;
  "vdate"?: any;
  "weekday"?: number;
  "vServiceType"?: string;
  "vTripId"?: string;
  "vTotalMealsUnits"?: number;
  "vUnits"?: number;
  "vAppName"?: string;
  "hash"?: string;
  "ctime": Date;
  "utime": Date;
  "dtime"?: Date;
  "dtime_str"?: string;
  "consumer_tenantId"?: number;
  "consumer_status"?: string;
  "consumer_internalID"?: string;
  "consumer_facilityID"?: string;
  "consumer_mci"?: string;
  "consumer_weekDays"?: any;
  "consumer_eligibility"?: any;
  "consumer_data"?: any;
  "consumer_person_lastname"?: string;
  "consumer_person_firstname"?: string;
  "consumer_person_dob"?: any;
  "consumer_person_data"?: any;
  "employee_tenantId"?: number;
  "employee_tenantIds"?: any;
  "employee_status"?: string;
  "employee_data"?: any;
  "employee_person_lastname"?: string;
  "employee_person_firstname"?: string;
  "employee_person_dob"?: any;
  "employee_person_data"?: any;
  "vehicle_internalId"?: number;
  "vehicle_vin"?: string;
}

export class SignatureView implements SignatureViewInterface {
  "id": number;
  "tenantId": number;
  "userId": number;
  "consumerId": number;
  "employeeId": number;
  "vehicleId": number;
  "requestID": string;
  "manifestRecId": string;
  "scheduledTime": string;
  "pickupTime": string;
  "dropoffTime": string;
  "arrivedTime": string;
  "imgFileId": string;
  "type": string;
  "captured": number;
  "unableToSign": number;
  "oneWayOnly": number;
  "dateTimeOfService": Date;
  "dateTime": Date;
  "marker": string;
  "status": string;
  "validationState": string;
  "location": GeoPoint;
  "meta": any;
  "note": string;
  "vdate": any;
  "weekday": number;
  "vServiceType": string;
  "vTripId": string;
  "vTotalMealsUnits": number;
  "vUnits": number;
  "vAppName": string;
  "hash": string;
  "ctime": Date;
  "utime": Date;
  "dtime": Date;
  "dtime_str": string;
  "consumer_tenantId": number;
  "consumer_status": string;
  "consumer_internalID": string;
  "consumer_facilityID": string;
  "consumer_mci": string;
  "consumer_weekDays": any;
  "consumer_eligibility": any;
  "consumer_data": any;
  "consumer_person_lastname": string;
  "consumer_person_firstname": string;
  "consumer_person_dob": any;
  "consumer_person_data": any;
  "employee_tenantId": number;
  "employee_tenantIds": any;
  "employee_status": string;
  "employee_data": any;
  "employee_person_lastname": string;
  "employee_person_firstname": string;
  "employee_person_dob": any;
  "employee_person_data": any;
  "vehicle_internalId": number;
  "vehicle_vin": string;
  constructor(data?: SignatureViewInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `SignatureView`.
   */
  public static getModelName() {
    return "SignatureView";
  }

  /**
  * This method creates an instance of SignatureView for dynamic purposes.
  **/
  public static factory(data: SignatureViewInterface): SignatureView{
    return new SignatureView(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SignatureView',
      plural: 'SignatureViews',
      path: 'SignatureViews',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "tenantId": {
          name: 'tenantId',
          type: 'number'
        },
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "consumerId": {
          name: 'consumerId',
          type: 'number'
        },
        "employeeId": {
          name: 'employeeId',
          type: 'number'
        },
        "vehicleId": {
          name: 'vehicleId',
          type: 'number'
        },
        "requestID": {
          name: 'requestID',
          type: 'string'
        },
        "manifestRecId": {
          name: 'manifestRecId',
          type: 'string'
        },
        "scheduledTime": {
          name: 'scheduledTime',
          type: 'string'
        },
        "pickupTime": {
          name: 'pickupTime',
          type: 'string'
        },
        "dropoffTime": {
          name: 'dropoffTime',
          type: 'string'
        },
        "arrivedTime": {
          name: 'arrivedTime',
          type: 'string'
        },
        "imgFileId": {
          name: 'imgFileId',
          type: 'string'
        },
        "type": {
          name: 'type',
          type: 'string'
        },
        "captured": {
          name: 'captured',
          type: 'number'
        },
        "unableToSign": {
          name: 'unableToSign',
          type: 'number'
        },
        "oneWayOnly": {
          name: 'oneWayOnly',
          type: 'number'
        },
        "dateTimeOfService": {
          name: 'dateTimeOfService',
          type: 'Date'
        },
        "dateTime": {
          name: 'dateTime',
          type: 'Date'
        },
        "marker": {
          name: 'marker',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'string'
        },
        "validationState": {
          name: 'validationState',
          type: 'string'
        },
        "location": {
          name: 'location',
          type: 'GeoPoint'
        },
        "meta": {
          name: 'meta',
          type: 'any'
        },
        "note": {
          name: 'note',
          type: 'string'
        },
        "vdate": {
          name: 'vdate',
          type: 'any'
        },
        "weekday": {
          name: 'weekday',
          type: 'number'
        },
        "vServiceType": {
          name: 'vServiceType',
          type: 'string'
        },
        "vTripId": {
          name: 'vTripId',
          type: 'string'
        },
        "vTotalMealsUnits": {
          name: 'vTotalMealsUnits',
          type: 'number'
        },
        "vUnits": {
          name: 'vUnits',
          type: 'number'
        },
        "vAppName": {
          name: 'vAppName',
          type: 'string'
        },
        "hash": {
          name: 'hash',
          type: 'string'
        },
        "ctime": {
          name: 'ctime',
          type: 'Date'
        },
        "utime": {
          name: 'utime',
          type: 'Date'
        },
        "dtime": {
          name: 'dtime',
          type: 'Date'
        },
        "dtime_str": {
          name: 'dtime_str',
          type: 'string'
        },
        "consumer_tenantId": {
          name: 'consumer_tenantId',
          type: 'number'
        },
        "consumer_status": {
          name: 'consumer_status',
          type: 'string'
        },
        "consumer_internalID": {
          name: 'consumer_internalID',
          type: 'string'
        },
        "consumer_facilityID": {
          name: 'consumer_facilityID',
          type: 'string'
        },
        "consumer_mci": {
          name: 'consumer_mci',
          type: 'string'
        },
        "consumer_weekDays": {
          name: 'consumer_weekDays',
          type: 'any'
        },
        "consumer_eligibility": {
          name: 'consumer_eligibility',
          type: 'any'
        },
        "consumer_data": {
          name: 'consumer_data',
          type: 'any'
        },
        "consumer_person_lastname": {
          name: 'consumer_person_lastname',
          type: 'string'
        },
        "consumer_person_firstname": {
          name: 'consumer_person_firstname',
          type: 'string'
        },
        "consumer_person_dob": {
          name: 'consumer_person_dob',
          type: 'any'
        },
        "consumer_person_data": {
          name: 'consumer_person_data',
          type: 'any'
        },
        "employee_tenantId": {
          name: 'employee_tenantId',
          type: 'number'
        },
        "employee_tenantIds": {
          name: 'employee_tenantIds',
          type: 'any'
        },
        "employee_status": {
          name: 'employee_status',
          type: 'string'
        },
        "employee_data": {
          name: 'employee_data',
          type: 'any'
        },
        "employee_person_lastname": {
          name: 'employee_person_lastname',
          type: 'string'
        },
        "employee_person_firstname": {
          name: 'employee_person_firstname',
          type: 'string'
        },
        "employee_person_dob": {
          name: 'employee_person_dob',
          type: 'any'
        },
        "employee_person_data": {
          name: 'employee_person_data',
          type: 'any'
        },
        "vehicle_internalId": {
          name: 'vehicle_internalId',
          type: 'number'
        },
        "vehicle_vin": {
          name: 'vehicle_vin',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}
